import Tab from './Tab';
import Tabs from './Tabs';
import TabPanel from './TabPanel';

export { Tabs, TabPanel };
export default Tab;
